import { configureStore } from '@reduxjs/toolkit'

import userReducer from './user';
import globalReducer from './global';
import loadingReducer from './loading.js';
import  rafflesReducer from './raffles.js';

const store = configureStore({
  reducer: {
    user: userReducer,
    global: globalReducer,
    loading: loadingReducer,
    raffles: rafflesReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  }),
})

export { store }
